<template>
  <div>
    <slot v-bind:text="text"/>

    <TextButton
      v-if="isTruncated"
      class="button--plain button--no-hover"
      @click="$emit('click')"
    >
      <slot name="buttonText">ver +</slot>
    </TextButton>
  </div>
</template>

<script>
import TextButton from '@/components/buttons/TextButton'

export default {
  components: {
    TextButton,
  },
  
  props: {
    maxLength: { type: Number, default: 100 },
    value: { type: String, required: true },
  },

  data: () => ({
    isOpen: false,
  }),

  computed: {
    text () {
      if (this.isTruncated) {
        return this.value.substr(0, this.maxLength) + '...'
      }

      return this.value
    },
    
    isTruncated () {
      return this.value.length >= this.maxLength
    }
  },  
}
</script>
